import React from 'react'

import SupportListWrapper from 'core/page/SupportListWrapper'
import { loadFailedExports } from '../state/actions'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { IExtendedColumn } from '@cbgms/components/grid/Types'
import { IFailedExport } from '@cbgms/api/modules/support'
import { TooltipButton } from '@cbgms/components/form/TooltipButton'
import { ListRow } from 'core/types/ListRow'
import { useTranslation } from 'react-i18next'
import { IPaginatedRequest } from '@cbgms/api'

export const mapLinkToColumn = (columns: IExtendedColumn[]) => {
  return columns.map(col => ({
    ...col,
    action:
      col.key === 'FailedExport.CompanyName'
        ? ({ data }: { data: { FailedExport: IFailedExport } }) => {
            return <Link to={`/companies/edit/${data.FailedExport.CompanyUUID}`}>{data.FailedExport.CompanyName}</Link>
          }
        : col.key === 'FailedExport.ShopID'
        ? ({ data }: { data: { FailedExport: IFailedExport } }) => (
            <Link to={`/companies/${data.FailedExport.CompanyUUID}/shops/edit/${data.FailedExport.ShopID}`}>
              {data.FailedExport.ShopID}
            </Link>
          )
        : col.action
  }))
}

const AccountancyList: React.FC = () => {
  const location = useLocation()
  const history = useHistory()
  const onClick = (e: { FailedExport: IFailedExport }) => {
    const params = new URLSearchParams()
    params.set('administrationDescription', e.FailedExport.AdministrationDescription)

    history.push({
      pathname: `${location.pathname}/errorlist/${e.FailedExport.ShopID}/${e.FailedExport.AdministrationSoftware}`,
      state: { administrationDescription: e.FailedExport.AdministrationDescription },
      search: params.toString()
    })
  }
  const { t } = useTranslation()

  const loadFailedExportsWithRequiredFields = (params: IPaginatedRequest) => {
    const requiredField = 'FailedExport.AdministrationDescription'
    const fields = params.fields ? (params.fields.includes(requiredField) ? params.fields : `${params.fields},${requiredField}`) : undefined
    return loadFailedExports({ ...params, fields })
  }

  const actionButtons = (row: ListRow<{ FailedExport: IFailedExport }>) => {
    return (
      <TooltipButton
        onClick={() => {
          const { ShopID, AdministrationSoftware, AdministrationDescription } = row.data.FailedExport
          const params = new URLSearchParams()
          params.set('administrationDescription', AdministrationDescription)

          history.push({
            pathname: `${location.pathname}/errorlist/${ShopID}/${AdministrationSoftware}`,
            state: { administrationDescription: AdministrationDescription },
            search: params.toString()
          })
        }}
        icon='search'
        title={t('reporting.open-error-details')}
      />
    )
  }

  return (
    <div>
      <SupportListWrapper
        actions={actionButtons}
        scope='failed-exports'
        type='list'
        onColumnMap={mapLinkToColumn}
        skipDryRun
        loadAction={loadFailedExportsWithRequiredFields}
        translationKey='failed-exports'
        onDoubleClick={onClick}
      />
    </div>
  )
}

export default AccountancyList
